import { useEffect, useMemo } from 'react';
import { useStorefront } from '../Context/StoreContext';
import { getApiBaseUrl } from '../lib/storefront/storeBootstrap';

const API_URL = getApiBaseUrl();

function getManifestLink() {
    let link = document.querySelector('link[rel="manifest"]');
    if (!link) {
        link = document.createElement('link');
        link.rel = 'manifest';
        document.head.appendChild(link);
    }
    return link;
}

/**
 * Points <link rel="manifest"> at this store's generated manifest, so an
 * installed storefront carries the merchant's name, icon and theme colour
 * instead of the platform defaults baked into public/manifest.json.
 */
export function useStoreManifest() {
    const { store } = useStorefront();

    const manifestHref = useMemo(() => {
        if (!API_URL || !store?.id) return '';
        return `${String(API_URL).replace(/\/$/, '')}/api/settings/manifest?storeId=${encodeURIComponent(store.id)}`;
    }, [store?.id]);

    useEffect(() => {
        if (!manifestHref) return undefined;

        const link = getManifestLink();
        const previousHref = link.getAttribute('href');
        const previousCrossOrigin = link.getAttribute('crossorigin');

        // The manifest lives on the API origin, so the fetch is cross-origin;
        // it is public data, requested without credentials.
        link.setAttribute('crossorigin', 'anonymous');
        link.setAttribute('href', manifestHref);

        return () => {
            if (previousHref) {
                link.setAttribute('href', previousHref);
            }
            if (previousCrossOrigin) {
                link.setAttribute('crossorigin', previousCrossOrigin);
            } else {
                link.removeAttribute('crossorigin');
            }
        };
    }, [manifestHref]);
}

export default useStoreManifest;
